import { render, staticRenderFns } from "./AppsToolbar.vue?vue&type=template&id=296d83ca"
import script from "./AppsToolbar.vue?vue&type=script&lang=js"
export * from "./AppsToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports